import React, {Component} from 'react';
import {Table, Button} from 'reactstrap';
import './SelfStudyList.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {Link} from "react-router-dom";
import moment from "moment";
import {Redirect} from "react-router-dom";
import RemoveSelfStudyModal from "../removeSelfStudyBookModal/RemoveSelfStudyModal.container";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import {Utils} from "../../../utils/utils";

class SelfStudyList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedSelfStudyBookId: null,
            selfStudyBookToRemove: null
        }
    }

    render() {
        if (!_.isNil(this.state.selectedSelfStudyBookId)) {
            return <Redirect to={"/edit-self-study-book?id=" + this.state.selectedSelfStudyBookId} push/>
        }

        return (
            <div className='self-study-list-component-container'>
                <FormWrapper successMessage={_.get(this.props.translation, 'self_study.remove_self_study_book_success_message')}>
                <div className='self-study-list-container'>
                    <h4 className='page-label'>{_.get(this.props.translation, 'self_study.table_label')}</h4>
                    {this.renderButtonsBar()}
                    {this.renderContent()}
                </div>
                <RemoveSelfStudyModal data={this.state.selfStudyBookToRemove} onCancelRemoving={this.handleCloseModal}/>
                </FormWrapper>
            </div>
        )
    }

    renderContent() {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="self-study-list-status-message-container">
                    <h6 className='page-label'>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="self-study-list-status-message-container">
                    <h6>{Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'self_study.no_data_label'))}</h6>
                </div>
            );
        }
        return [
            <div className="self-study-list-relative-header" key="self-study-list-relative-header">
                <div>{_.get(this.props.translation, 'self_study.expose_label')}</div>
            </div>,
            <Table className='self-study-list-table' key="self-study-list-table">
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'self_study.domain_label')}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.title_label)}</th>
                    <th>{_.get(this.props.translation, 'self_study.publisher_label')}</th>
                    <th>{_.get(this.props.translation, 'self_study.isbn_label')}</th>
                    <th>{_.get(this.props.translation, 'self_study.study_date_label')}</th>
                    <th className='self-study-expose-icon-th'>{_.get(this.props.translation, 'self_study.expose_label')}</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderStaffData()}
                </tbody>
            </Table>
        ]
    }

    renderStaffData() {
        return _.map(this.props.data, (book, index) => (
            <tr key={index} className='self-study-list-row' onClick={this.handleRowClick(book.id)}>
                <td className='domain-td' data-th={_.get(this.props.translation, 'self_study.domain_label') + ':'}>
                    {_.get(this.props.translation, 'self_study.domains.' + book.domain)}
                </td>
                <td className='title-td' data-th={_.get(this.props.translation, sharedLabelsPath.title_label) + ':'}>
                    {book.title}
                </td>
                <td className='publisher-td' data-th={_.get(this.props.translation, 'self_study.publisher_label') + ':'}>
                    {book.publisher}
                </td>
                <td className='isbn-td' data-th={_.get(this.props.translation, 'self_study.isbn_label') + ':'}>
                    {book.isbn || ''}
                </td>
                <td className='study-date-td' data-th={_.get(this.props.translation, 'self_study.study_date_label') + ':'}>
                    {moment(book.studyDate).format('LL')}
                </td>
                <td className='self-study-expose-icon-td'>
                    <IconContainer
                        icon={book.expose ? "check_box" : "check_box_outline_blank"}
                        onClick={this.handleExposeIconClick(book)}
                        key={"expose-self-study-member-icon-" + book.id}
                        className="expose-self-study-member-icon"
                        title={_.get(this.props.translation, 'self_study.expose_label')}
                    />
                </td>
                <td className='self-study-edit-icon-td'>
                    <IconContainer
                        icon="create"
                        className="edit-self-study-member-icon"
                        title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                    />
                </td>
                <td className='self-study-remove-icon-td'>
                    <IconContainer
                        onClick={this.handleRemoveIconClick(book)}
                        icon="trash"
                        className="delete-self-study-member-icon"
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                    />
                </td>
            </tr>
        ))
    }

    renderButtonsBar() {
        return (
            <div className='add-self-study-button-container'>
                <Button tag={Link} to="/add-self-study-book" className='add-self-study-button olive-green-btn'
                        onClick={this.onChangeAnchorButtonClick}>
                    {_.get(this.props.translation, sharedLabelsPath.add_button)}
                </Button>
            </div>
        );
    }

    componentDidMount() {
        this.props.onMount();
    }

    handleRowClick = (id) => () => {
        this.setState({selectedSelfStudyBookId: id});
    };

    handleRemoveIconClick = (book) => (e) => {
        e.stopPropagation();
        this.setState({selfStudyBookToRemove: book});
        this.props.onBookRemove();
    };

    handleCloseModal = () => {
        this.setState({selfStudyBookToRemove: null});
    };

    handleExposeIconClick = (book) => (e) => {
        e.stopPropagation();

        let data = book;
        data.expose = !book.expose;

        this.props.onBookUpdate(data.id, data);
    };
}

SelfStudyList.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    translation: PropTypes.object.isRequired,
    onBookRemove: PropTypes.func,
    onMount: PropTypes.func,
    onRemove: PropTypes.func,
    onBookUpdate: PropTypes.func
};

export default SelfStudyList;



// WEBPACK FOOTER //
// ./src/components/selfStudyManagement/selfStudyList/SelfStudyList.js